import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOkcupidComponent } from './simple-icons-okcupid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOkcupidComponent ],
    exports:      [ SimpleIconsOkcupidComponent ],
    bootstrap:    []
})
export class SimpleIconsOkcupidModule {}
